import React from 'react'
import Banner from './Banner'
import { FlexRow, Text, Icon } from 'elements'

export default function ConnectionBanner({ onClose }) {
  return (
    <Banner onClose={onClose}>
      <FlexRow>
        <Icon name="info-circle" size="medium" mr="xlarge" />
        <Text color="inherit" fontWeight="bold">
          Your integration could not be connected. Please reconnect and retry the report.
        </Text>
      </FlexRow>
    </Banner>
  )
}
